import React from "react";
import { StatusChip } from "../../Settings/GoalsSection/styles";
import { PlanLink } from "../styles";
import {
  PlanJustEndedInfo,
  PlanJustEndedList,
  PlanJustEndedRow,
} from "./styles";
import { PlanJustEndedProps } from "./types";

export const PlanJustEnded: React.FC<PlanJustEndedProps> = ({ goals }) => {
  if (goals.length === 0) {
    return null;
  }

  return (
    <PlanJustEndedList aria-label="Goals that just ended">
      {goals.map(({ key, goal, linkHref, linkLabel }) => (
        <PlanJustEndedRow key={key} data-testid="plan-just-ended">
          <PlanJustEndedInfo>
            <strong>{goal.name}</strong>
            {goal.statusLabel && (
              <StatusChip $tone={goal.statusTone}>
                {goal.statusLabel}
              </StatusChip>
            )}
          </PlanJustEndedInfo>
          <PlanLink href={linkHref}>{linkLabel}</PlanLink>
        </PlanJustEndedRow>
      ))}
    </PlanJustEndedList>
  );
};
